class IsObjectEmpty {
  constructor() {}

  /**
   * Check if an object is empty
   *
   * @param object
   */
  test(object) {
    for (var key in object) {
      if (object.prototype.hasOwnProperty.call(object, key)) return false;
    }
    return true;
  }
}

export default IsObjectEmpty;
